import axiosRequest from "@/api/axios-optimize"

// 获取列表
export function getList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/inventory/record`, { params: data, ...config})
}
